/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import $ from 'jquery';
window.$ = $;
window.jQuery = $;
window.Job = '';
window.List = [];

import {categoryDropDown} from './front/_front';
import {categorySelection} from './front/_front';
import {productTabs} from './front/_front';
import {floating_labels} from "./front/_floting-labels";
import {navigation} from "./_navigation";
import step1Standard from "./_step1Standard";
import step2Standard from "./_step2Standard";
import step3Standard from "./_step3Standard";
import step4Standard from "./_step4Standard";

$(document).ready(() => {

    categoryDropDown();
    categorySelection();
    productTabs();
    floating_labels();

    navigation();

    step1Standard();
    step2Standard();
    step3Standard();
    step4Standard();

});